import { NumberToolParameter } from './numberToolParameter';
import { StringToolParameter } from './stringToolParameter';
import { ToolEnumTypesMap } from './toolEnumTypesMap';
import { ToolParameterType, ToolParameterValueType } from './toolParameter';
export class ToolParameterHelper {
    static makeReusableParam(key, value) {
        switch (typeof value) {
            case 'string':
                return StringToolParameter.Reusable(key, value);
            case 'number':
                return NumberToolParameter.Reusable(key, value);
            default:
                throw new Error(`Invalid type for reusable parameter: ${typeof value}`);
        }
    }
    static parseToolParameterString(variable) {
        if (!variable.startsWith('@'))
            throw new Error(`Variable has invalid format, must start with '@': ${variable}`);
        // get the type from @global.xxx or @pipe.xxx
        const firstDotIndex = variable.indexOf('.');
        let paramTypeStr = '';
        let varName;
        if (firstDotIndex === -1) {
            varName = variable.substring(1);
        }
        else {
            paramTypeStr = variable.substring(1, firstDotIndex);
            varName = variable.substring(firstDotIndex + 1);
        }
        let paramType;
        switch (paramTypeStr) {
            case ToolParameterType.GLOBAL:
                paramType = ToolParameterType.GLOBAL;
                break;
            case ToolParameterType.PIPE:
            case ToolParameterType.CALC: // for Incentives
                paramType = ToolParameterType.PIPE;
                break;
            case ToolParameterType.REUSABLE:
            case ToolParameterType.TOOL: // for Formulas
                paramType = ToolParameterType.REUSABLE;
                break;
            default:
        }
        return { varName, paramType };
    }
    static getToolParameter(toolParameters, paramName, toolParameterType) {
        let toolParameter;
        if (toolParameterType) {
            toolParameter = toolParameters.get(toolParameterType, paramName, false);
        }
        else {
            toolParameter = toolParameters.get(ToolParameterType.REUSABLE, paramName, false);
            if (!toolParameter) {
                toolParameter = toolParameters.get(ToolParameterType.TOOL, paramName, false);
            }
            if (!toolParameter) {
                toolParameter = toolParameters.get(ToolParameterType.PIPE, paramName, false);
            }
            if (!toolParameter) {
                toolParameter = toolParameters.get(ToolParameterType.CALC, paramName, false);
            }
            if (!toolParameter) {
                toolParameter = toolParameters.get(ToolParameterType.GLOBAL, paramName, false);
            }
        }
        // check only undefined; '' values are valid but return false for !toolParameter
        if (toolParameter === undefined)
            throw new Error(`ToolParameter ${paramName} not found`); // should it throw?
        // this code is unneeded if we do the validation in enumparmaeter itself
        if (toolParameter.valueType === ToolParameterValueType.ENUM) {
            const enumParam = toolParameter;
            if (!ToolEnumTypesMap.get(enumParam.toolEnumType).includes(enumParam.value))
                throw new Error(`Value ${enumParam.value} not in allowed values for enum ToolParameter ${paramName}`);
        }
        return toolParameter;
    }
}
//# sourceMappingURL=toolParameterHelper.js.map